import React from 'react';
import { Link } from 'react-router-dom';
/** components **/
import { SurveyLayout } from 'components/organisms';
/** styles **/
import s from '../styles/pages/survey.module.scss';
/** images **/
import Parapara01 from 'assets/images/parapara01.png';
import Parapara02 from 'assets/images/parapara02.png';
import Parapara03 from 'assets/images/parapara03.png';
import Parapara04 from 'assets/images/parapara04.png';
import Parapara05 from 'assets/images/parapara05.png';
import Parapara06 from 'assets/images/parapara06.png';
import Parapara07 from 'assets/images/parapara07.png';
import Parapara08 from 'assets/images/parapara08.png';
import Parapara09 from 'assets/images/parapara09.png';
import Parapara10 from 'assets/images/parapara010.png';
import { ReactComponent as TopHuman } from 'assets/images/top-human.svg';
import { ReactComponent as GreenCircleArrow } from 'assets/images/green-circle-arrow.svg';
import { ReactComponent as BlackCircleArrow } from 'assets/images/black-circle-arrow.svg';
// Swiper
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export const Survey: React.FC = () => {

  const images = [
    Parapara01, Parapara02, Parapara03, Parapara04, Parapara05,
    Parapara06, Parapara07, Parapara08, Parapara09, Parapara10
  ];

  return (
    <SurveyLayout hasFixedBanner={true}>
      <div className={s.surveyWrapper}>
        {/* タイトルセクション */}
        <section className={s.titleSection}>
          <p className={s.contentsTitle}>ペットのコンシェルジュがいる<br />
            賃貸マンションプロジェクト<br />
            P-man</p>
          <p className={s.leadText}>妄想マンション投票　第２弾</p>
        </section>

        {/* 動画セクション */}
        <section className={s.videoSection}>
          <div className={s.videoContent}>
            <p className={s.videoTitle}>P-manとは？
            </p>
            <div className={s.videoWrapper}>
              <iframe
                src="https://www.youtube.com/embed/4aqQgPjpXzA"
                title="P-man紹介動画"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </div>
        </section>

        {/* 投票誘導セクション */}
        <section className={s.voteSection}>
          <div className={s.voteContent}>
            <div className={s.partnerInfo}>
              <p className={s.partnerText}>
                三菱地所が<br />
                ともに考え<br />
                ともに創ります
              </p>
              <TopHuman className={s.conciergeImage} />
            </div>
          </div>
        </section>

        {/* アプローチセクション */}
        <section className={s.approachSection}>
          <div className={s.approachContent}>
            <div className={s.sliderWrapper}>
              <Swiper
                modules={[Navigation, Pagination]}
                navigation={{
                  nextEl: '.swiper-button-next-custom',
                  prevEl: '.swiper-button-prev-custom',
                }}
                pagination={{
                  el: '.swiper-pagination',
                  type: 'fraction',
                  renderFraction: function (currentClass: string, totalClass: string) {
                    return '<span class="' + currentClass + '" style="font-size: 17px; font-weight: bold; color: #000;"></span>' +
                      ' / ' +
                      '<span class="' + totalClass + '" style="font-size: 17px; font-weight: bold; color: #000;"></span>';
                  },
                }}
                loop={true}
                centeredSlides={true}
                breakpoints={{
                  768: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    loop: false,
                  },
                  0: {
                    slidesPerView: 1.2,
                    spaceBetween: 10,
                    loop: false,
                  },
                }}
                className={s.slider}
              >
                {images.map((image, index) => (
                  <SwiperSlide key={index}>
                    <div className={s.slideImage}>
                      <img src={image} alt={`スライド ${index + 1}`} />
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>

              <div className={s.sliderControls}>
                <button className={`swiper-button-prev-custom ${s.prevButton}`}>
                  <BlackCircleArrow className={s.prevArrow} />
                </button>
                <div className={s.paginationWrapper}>
                  <div className="swiper-pagination" />
                </div>
                <button className={`swiper-button-next-custom ${s.nextButton}`}>
                  <BlackCircleArrow className={s.nextArrow} />
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div className={s.fixedVoteButton}>
        <Link to="/survey/benefits" className={s.voteButton}>
          <span className={s.voteButtonText}>投票する</span>
          <GreenCircleArrow className={s.voteButtonIcon} />
        </Link>
      </div>
    </SurveyLayout>
  );
};